import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { Alert } from "reactstrap";
import {
  intersectDocumentsByIds,
  normalizeDocumentIds,
} from "helpers/customPageDocuments";
import { myDocuments } from "helpers/backend-helper";
import CustomPageResourcesTable from "./CustomPageResourcesTable";

const CustomPageResourcesMount = ({ documentIds = [], htmlHost = null, showDownloadAll = false }) => {
  const ids = useMemo(() => normalizeDocumentIds(documentIds), [documentIds]);
  const idsKey = ids.join(",");
  const [documents, setDocuments] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ids.length) {
      setDocuments([]);
      setError(null);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      setError(null);
      try {
        const response = await myDocuments({ ids: idsKey });
        if (cancelled) return;
        const items = response?.data?.items || [];
        setDocuments(intersectDocumentsByIds(items, ids));
      } catch (e) {
        if (cancelled) return;
        setDocuments([]);
        setError(e?.message || "Failed to load resources");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [ids, idsKey]);

  if (!ids.length) return null;

  let content = null;
  if (error) {
    content = <Alert color="danger">{error}</Alert>;
  } else if (documents.length) {
    content = <CustomPageResourcesTable documents={documents} showDownloadAll={showDownloadAll} />;
  } else {
    return null;
  }

  if (htmlHost) {
    return createPortal(content, htmlHost);
  }

  return content;
};

CustomPageResourcesMount.propTypes = {
  documentIds: PropTypes.arrayOf(PropTypes.string),
  htmlHost: PropTypes.any,
  showDownloadAll: PropTypes.bool,
};

export default CustomPageResourcesMount;
